import { Component, OnInit, inject, ViewChild, ElementRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { InicioService } from '../../services/inicio.service';
import { Router } from '@angular/router';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ModalComponent } from "../modal/modal.component";


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, ModalComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  providers: [provideNgxMask()],
})
export class LoginComponent implements OnInit{
  @ViewChild("content",{static: true}) content!: ElementRef;
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  public frmEntidadTrabajo: FormGroup;
  public frmAprendiz: FormGroup;
  public frmInstitucional: FormGroup;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  mascara: string = '00000000';

  private modalService = inject(NgbModal);
  public accesoService = inject(InicioService);
  public rutas = inject(Router);

  ngOnInit(): void {
  }

  constructor() {
    this.frmEntidadTrabajo = new FormGroup({
      mil: new FormControl('', [Validators.required]),
      pass: new FormControl('', [Validators.required]),
    });

    this.frmAprendiz = new FormGroup({
      tp_doc: new FormControl('V', [Validators.required]),
      nro_doc: new FormControl('', [Validators.required]),
      pass: new FormControl('', [Validators.required])
    })

    this.frmInstitucional = new FormGroup({
      mil: new FormControl('', [Validators.required]),
      pass: new FormControl('', [Validators.required]),
    });
  }

  ver_pass(tp: number){
    let pass = (document.getElementById('password'+tp) as HTMLInputElement);
    pass.getAttribute('type') == 'password' ? pass.setAttribute('type', 'text') : pass.setAttribute('type', 'password');
  }

  validador(){
    let tpo = this.frmAprendiz.get('tp_doc')?.getRawValue();
    this.frmAprendiz.get('nro_doc')?.setValue('');
    if(tpo == 'V'){
      this.mascara = '00000000';
    }
    else if(tpo == 'E'){
      this.mascara = '000000000';
    }
    else if(tpo == 'P'){
      this.mascara = '0000000000';
    }
    else if(tpo == 'G'){
      this.mascara = '0000000000';
    }
    console.log('siiiiiiiii:  ',tpo)
  }


  async login(tipo: number){

    let form: any;
    let objeto: any;
    if (tipo == 1){
      form = this.frmEntidadTrabajo
      objeto = {
        username: form.value.mil,
        password: form.value.pass,
        tipo_usuario: tipo
      }
    }
    else if(tipo == 2){
      form = this.frmAprendiz
      objeto = {
        username: form.value.nro_doc,
        password: form.value.pass,
        tipo_usuario: tipo
      }
    }
    else{
      form = this.frmInstitucional
      objeto = {
        username: form.value.mil,
        password: form.value.pass,
        tipo_usuario: tipo
      }
    }

    if(form.valid) {

      this.modalService.open(this.content, {
        backdrop: 'static',
        centered: true,
        windowClass: 'modalClass',
        keyboard: false
      });


      await this.accesoService.login(objeto).subscribe({
        next:(dt)=>{
          console.log('siiii:  ',dt)
          this.modalService.dismissAll(this.content)
          if(dt.data){
            this.rutas.navigate(['/panel-admin']);
          }
          else
          {
            this.titulo = '!ADVERTENCIA¡';
            this.tipo_color = 'warning';
            this.letra_color = 'dark';
            //this.mensaje = '!El usuario no existe!';
            this.mensaje = dt.token;
            this.mdl.alerta();
          }

        },
        error: (err) => {
          this.modalService.dismissAll(this.content)
          this.mdl.cerrar();
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'el usuario no existe, los datos son incorrectos o el usuario está inactivo';
          this.mdl.alerta();
        }
      })
    }else{
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = '!Debes de llenar todos los campos del formularios correspondiente!';
      this.mdl.alerta();
    }

  }


}
